import L from "leaflet";

export const VenueIconInfo = L.icon({
  iconUrl: require("../../assets/location_info.png"),
  iconSize: [38, 53]
});
